import React from "react";

interface Props {
    tags: string;
    setTags: (tags: string) => void;
    placeholder?: string;
    label?: string;
}

const POPULAR_TAGS = [
    "carpet", 
    "frontage", 
    "menu", 
    "beer garden", 
    "sign", 
];

function PhotoTagInput(props: Props) {
    const handleTagClick = (suggestedTag: string) => {
        const currentTags = props.tags 
            ? props.tags.split(',').map(t => t.trim()).filter(t => t) 
            : [];
        
        if (currentTags.includes(suggestedTag)) {
            // Remove the tag if it already exists
            const updatedTags = currentTags.filter(tag => tag !== suggestedTag);
            props.setTags(updatedTags.join(', '));
        } else {
            // Add the tag if it doesn't exist
            props.setTags(
                currentTags.length > 0 
                    ? `${props.tags}, ${suggestedTag}` 
                    : suggestedTag
            );
        }
    };

    return (
        <div style={{backgroundColor: '#303030', padding: '0.15rem', borderRadius: '0.25rem'}}>
            <label style={{marginBottom: "0.5rem", display: "block"}}>{props.label || "Select from popular tags, or create your own:"}</label>
            <div className="mb-2">
                {POPULAR_TAGS.map((suggestedTag) => {
                    const currentTags = props.tags 
                        ? props.tags.split(',').map(t => t.trim()).filter(t => t) 
                        : [];
                    const isSelected = currentTags.includes(suggestedTag);
                    
                    return (
                        <button
                            key={suggestedTag}
                            type="button"
                            className="btn btn-sm mr-1 mb-1"
                            style={{
                                fontSize: "0.75rem", 
                                padding: "0.15rem 0.4rem",
                                backgroundColor: isSelected ? "white" : "transparent",
                                borderColor: "white",
                                color: isSelected ? "black" : "white"
                            }}
                            onClick={() => handleTagClick(suggestedTag)}
                        >
                            {suggestedTag}
                        </button>
                    );
                })}
            </div>
            <input 
                type="text"
                placeholder={props.placeholder || "E.g. bar, food, art"}
                className="form-control tag-input"
                value={props.tags}
                id="tags"
                style={{width: "100%"}}
                onChange={e => props.setTags(e.target.value)}
            />
        </div>
    );
}

export default PhotoTagInput;
